module.exports = __webpack_public_path__ + "static/media/studio-etc10.ac346257.png";